var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo/angular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 1.08333L2.16667 4.98333L3.79167 19.3917L13 24.9167L22.2083 19.3917L23.8333 4.98333L13 1.08333Z",
    fill: "#DD0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 1.08333V24.9167L22.2083 19.3917L23.8333 4.98333L13 1.08333Z",
    fill: "#C3002F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13 3.9L6.28333 18.9583H8.775L10.1292 15.6H15.8708L17.225 18.9583H19.7167L13 3.9ZM14.95 13.5417H11.05L13 8.775L14.95 13.5417Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAngular);
export default __webpack_public_path__ + "static/media/logo-angular.d860b16911c6f5d6fd8cbf8f0f8cf8cc.svg";
export { ForwardRef as ReactComponent };